import styled from '@emotion/styled';
import React from 'react';

import { mediaQueries } from 'src/shared/styles/variables';

const StyledWrapper = styled('div')({
    maxWidth: 1024,
    width: '100%',
    margin: '0 auto',
    padding: '0 50px',
    [mediaQueries.md]: {
        padding: '0 20px',
    },
    [mediaQueries.sm]: {
        padding: 0,
    },
});

interface Props {
    children: React.ReactChild | React.ReactChild[];
}

export const Wrapper = (props: Props) => <StyledWrapper>{props.children}</StyledWrapper>;
